<template>
  <div
    data-slot="field-group"
    :class="
      cn(
        'tw:group/field-group tw:@container/field-group tw:flex tw:w-full tw:flex-col tw:gap-4 tw:data-[slot=checkbox-group]:gap-3 tw:[&>[data-slot=field-group]]:gap-4',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>

<script setup>
import { cn } from '@/shared/utilities/classes';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    default: undefined,
    required: false,
    skipCheck: true,
  },
});
</script>
